function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 626,
  cy: 207,
  r: 200,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 626,
  cy: 207,
  r: 175,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 626,
  cy: 207,
  r: 150,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 626,
  cy: 207,
  r: 125,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 626,
  cy: 207,
  r: 100,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 626,
  cy: 207,
  r: 75,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 626,
  cy: 207,
  r: 50,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 626,
  cy: 207,
  r: 25,
  stroke: "#E0F1FF",
  strokeWidth: 10
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#404_svg__clip0_2319_18152)",
  stroke: "#E0F1FF",
  strokeWidth: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M246 207h-71.5l61-226"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247 232H142l69-257"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247 257H109.5L187-32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247 282H77l86-321.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247 307H44.5l94-352"
}), /*#__PURE__*/React.createElement("path", {
  d: "M247 332H12L114-50.5"
}));

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 235,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 260,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 285,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 310,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 335,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 360,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#404_svg__clip1_2319_18152)",
  stroke: "#E0F1FF",
  strokeWidth: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M1117 207h-71.5l61-226"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1118 232h-105l69-257"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1118 257H980.5L1058-32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1118 282H948l86-321.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1118 307H915.5l94-352"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1118 332H883L985-50.5"
}));

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 1106,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 1131,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 1156,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 1181,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 1206,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 1231,
  y: 105,
  width: 10,
  height: 305,
  rx: 5,
  fill: "#E0F1FF"
});

var _ref23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "404_svg__clip0_2319_18152"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5 0h230v338H5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "404_svg__clip1_2319_18152"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M876 0h230v338H876z"
})));

function Svg404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1252 412",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

export default "data:image/svg+xml;base64,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";
export { Svg404 as ReactComponent };